/**
 * Universal Image URL Helper
 * Ensures all image URLs are correctly formatted for both development and production
 */

const API_URL = process.env.REACT_APP_BACKEND_URL || '';

/**
 * Converts any image URL to a fully qualified URL
 * @param {string} url - The image URL from the database
 * @param {string} fallback - Fallback image URL if original is invalid
 * @returns {string} - Fully qualified image URL
 */
export const getImageUrl = (url, fallback = 'https://images.unsplash.com/photo-1504711434969-e33886168f5c?w=800&h=800&fit=crop') => {
  // If no URL provided, return fallback
  if (!url) return fallback;
  
  // If already a full HTTP/HTTPS URL, return as-is
  if (url.startsWith('http://') || url.startsWith('https://')) {
    return url;
  }
  
  // If starts with /api/uploads, prepend API_URL
  if (url.startsWith('/api/uploads')) {
    return `${API_URL}${url}`;
  }
  
  // If starts with /uploads (without /api/), add /api/ prefix
  if (url.startsWith('/uploads')) {
    return `${API_URL}/api${url}`;
  }
  
  // If it's a relative path without leading slash, assume it's in uploads
  if (!url.startsWith('/')) {
    return `${API_URL}/api/uploads/${url}`;
  }
  
  // Default: prepend API_URL
  return `${API_URL}${url}`;
};

/**
 * Get PDF URL
 */
export const getPdfUrl = (url, fallback = '') => {
  if (!url) return fallback;
  
  if (url.startsWith('http://') || url.startsWith('https://')) {
    return url;
  }
  
  if (url.startsWith('/api/uploads')) {
    return `${API_URL}${url}`;
  }
  
  if (url.startsWith('/uploads')) {
    return `${API_URL}/api${url}`;
  }
  
  return `${API_URL}${url}`;
};

export default getImageUrl;
